import {  observable, action, observe } from 'mobx';
import base from '../../tool/base';

import util from '../../util/index';
import { message } from 'antd';
message.config({
  top: 20,
});
const {
  catchApiError,
  getAccessToken,
} = util;
export class SysStore {
  constructor(routing) {
    this.routing = routing;
  }
  @observable sysPerson = {};
  @observable current = 1;
  @observable pageSize = 10;
  @observable formLoading = false;
  @observable loading = false;
  @observable userList = [];
  @observable userCount = 0;
  @observable checkList = [];
  @observable checkCount = 0;
  @observable joinList = [];
  @observable joinCount = 0;
  @observable buyList = [];
  @observable buyCount = 0;
  @observable appList = [];
  @observable appCount = 0;
  @observable fbList = [];
  @observable fbCount = 0;
  @observable fbFiles = [];
  @observable ecologyList = [];
  @observable genreList = [];
  @observable pccount = 0;
  @observable mobilecount = 0;

  @action
  init = (initTable = true) => {
    this.current = 1;
    this.pageSize = 10;
    this.loading = false;
    this.formLoading = false;
    this.pccount = 0;
    this.mobilecount = 0;
    if (initTable) {
      this.userList = [];
      this.userCount = 0;
      this.checkList = [];
      this.checkCount = 0;
      this.joinList = [];
      this.joinCount = 0;
      this.buyList = [];
      this.buyCount = 0;
      this.appList = [];
      this.appCount = 0;
      this.fbList = [];
      this.fbCount = 0;
      this.ecologyList = [];
      this.genreList = [];
    }
   }

  @action
  setMobxState = (params = {}) => {
    Object.keys(params).forEach(v => {
      this[v] = params[v];
    });
  }
  @action
  getSysPerson = (params = {})   => {
    const param = {
      ...params,
      access_token: getAccessToken(),
    }
    return new Promise(resolve => {
      base.callApi('/v1/sys/sysperson', 'POST', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then(data => {
        if (data.status === 'true') {
          this.sysPerson = data;
        }
        resolve(data);
      });
    });
  }
  @action
  doUserPwdChange = (params = {}) => {
    this.formLoading = true;
    const param = {
      newpass: params.pass,
      access_token: getAccessToken(),
    }
    return new Promise(resolve => {
      base.callApi('/v1/sys/pass/edit', 'POST', param, 'json', 'text').then(data => {
        data.status === 'true' ? message.success('保存成功') : message.error(data.msg || '保存失败');
        this.formLoading = false;
        resolve(data);
      });
    })
  }
  @action
  getSysPersons = (params = {}) => {
    this.loading = true;
    const param = {
      ...params,
      isDe: '0',
      current: params.current || this.current,
      pageSize: params.pageSize || this.pageSize,
      access_token: getAccessToken(),
    }
    return new Promise(resolve => {
      base.callApi('/v1/sys/person', 'GET', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then(data => {
        if (data.status === 'true') {
          this.userList = data.List;
          this.userCount = data.count;
        }
        this.loading = false;
        resolve(data);
      });
    });
  }
  @action
  update = (params = {}) => {
    this.formLoading = true;
    const param = {
      ...params,
      access_token: getAccessToken(),
    }
    delete param.mid;
    return new Promise(resolve => {
      base.callApi(`/v1/sys/person/${params.mid}/update`, 'POST', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then(data => {
        data.status === 'true' ? message.success('修改成功') : message.error('操作失败，请重试！');
        this.formLoading = false;
        resolve(data);
      });
    });
  }
  @action
  getCheckList = (params = {}) => {
    this.loading = true;
    const pageSize = params.pageSize || this.pageSize;
    const current = params.current || this.current;
    const param = {
      ...params,
      access_token: getAccessToken(),
      pageSize,
      current,
      min: (current - 1) * 10 + 1,
			max: current * 10,
			time: 0,
    }
    return new Promise(resolve => {
      base.callApi('/v1.1/sys/checkList', 'GET', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then(data => {
        if (data.status === 'true') {
          this.checkList = data.List;
          this.checkCount = data.count;
        }
        this.loading = false;
        resolve(data);
      });
    });
  }
  @action
  getJoinList = (params = {}) => {
    this.loading = true;
    const param = {
      ...params,
      isDe: '0',
      current: params.current || this.current,
      pageSize: params.pageSize || this.pageSize,
      access_token: getAccessToken(),
    }
    if (param.contacted === 'all') delete param.contacted;
    return new Promise(resolve => {
      base.callApi('/v2/join/joinList', 'POST', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then(data => {
        if (data.status) {
          this.joinList = data.list;
          this.joinCount = data.count;
        }
        this.loading = false;
        resolve(data);
      });
    });
  }
  @action
  editJoinList = (params = {}) => {
    const param = {
      ...params,
      access_token: getAccessToken(),
    }
    return new Promise(resolve => {
      base.callApi(`/v2/join/joinlist/${params.jl_id}/edit`, 'POST', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then(data => {
        data.status === 'true' ? message.success('操作成功') : message.error('操作失败');
        resolve(data);
      });
    });
  }
  @action
  getAppBuy = (params = {}) => {
    this.loading = true;
    const param = {
      ...params,
      current: params.current || this.current,
      pageSize: params.pageSize || this.pageSize,
      access_token: getAccessToken(),
    }
    return new Promise(resolve => {
      base.callApi('/v1/sys/buy', 'GET', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then(data => {
        if (data.status === 'true') {
          this.buyList = data.List;
          this.buyCount = data.Count;
        }
        this.loading = false;
        resolve(data);
      });
    });
  }
  @action
  editApp = (params = {}) => {
    const param = {
      ...params,
      access_token: getAccessToken(),
    }
    return new Promise(resolve => {
      base.callApi(`/v1/sys/buy/${params.tm_id}/edit`, 'POST', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then(data => {
        data.status === 'true' ? message.success('操作成功') : message.error('操作失败，请重试！');
        resolve(data);
      });
    });
  }
  @action
  getApp = (params = {}) => {
    const param = {
      ...params,
      current: params.current || this.current,
      pageSize: params.pageSize || this.pageSize,
      access_token: getAccessToken(),
    }
    return new Promise(resolve => {
      base.callApi('/v1/sys/app', 'GET', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then(data => {
        if (data.status === 'true') {
          this.appList = data.app;
          this.appCount = data.count;
        }
        resolve(data);
      });
    });
  }
  @action
  getFbList = (params = {}) => {
    const param = {
      ...params,
      current: params.current || this.current,
      pageSize: params.pageSize || this.pageSize,
      access_token: getAccessToken(),
    }
    return new Promise(resolve => {
      base.callApi('/v2/sys/fblist', 'GET', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then(data => {
        if (data.status) {
          this.fbList = data.list;
          this.fbCount = data.count;
        }
        resolve(data);
      });
    });
  }
  @action
  editFb = (params = {}) => {
    this.formLoading = true;
    const param = {
      ...params,
      access_token: getAccessToken(),
    }
    return new Promise(resolve => {
      base.callApi(`/v2/sys/fblist/${params.uuid}/edit`, 'POST', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then(data => {
        this.formLoading = false;
        resolve(data);
      });
    });
  }
  @action
  getEcology = (params = {}) => {
    const param = {
      ...params,
      access_token: getAccessToken(),
    }
    return new Promise(resolve => {
      base.callApi('/v1.1/ecology', 'GET', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then(data => {
        if (data.status === 'true') {
          this.ecologyList = data.list;
        }
        resolve(data);
      });
    });
  }
  @action
  addEcFile = (params = {}) => {
    const param = {
      ...params,
      access_token: getAccessToken(),
    }
    return new Promise(resolve => {
      base.callApi('/v1.1/sys/ecfile/add', 'POST', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then(data => {
        data.status === 'true' ? message.success('操作成功') : message.error('操作失败');
        resolve(data);
      });
    });
  }
  @action getHash = (prefix) => prefix + Math.random().toString(36).substr(2, 6);
  @action
  getGenre = (params = {}) => {
    this.loading = true;
    const param = {
      ...params,
      access_token: getAccessToken(),
      type: params.type || "n",
      gorder: 0,
    }
    return new Promise(resolve => {
      base.callApi('/v1.1/sys/genre', 'GET', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then(data => {
        if (data.status) {
          const datas = data.genre.map(v => {
            return {
              ...v,
              id: this.getHash('genrenList'),
            }
          });
          datas.unshift({
            id: this.getHash('genrenList'),
            g_id: '-1',
            name: '',
            g_order: '',
          });
          this.genreList = datas;
        }
        this.loading = false;
        resolve(data);
      });
    });
  }
  @action
  addGenre = (params = {}) => {
    const param = {
      ...params,
      access_token: getAccessToken(),
      type: params.type || "n",
    }
    return new Promise(resolve => {
      base.callApi('/v1.1/sys/genre', 'POST', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then(data => {
        data.status === 'true' ? message.success('操作成功') : message.error('操作失败');
        resolve(data);
      });
    });
  }
  @action
  editGenre = (params = {}) => {
    const param = {
      ...params,
      access_token: getAccessToken(),
      type: params.type || "n",
    }
    return new Promise(resolve => {
      base.callApi(`/v1.1/sys/genre/${params.gid}`, 'POST', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then(data => {
        data.status === 'true' ? message.success('操作成功') : message.error('操作失败');
        resolve(data);
      });
    });
  }
  @action
  delGenre = (params = {}) => {
    const param = {
      ...params,
      access_token: getAccessToken(),
      type: params.type || 'n',
    }
    return new Promise(resolve => {
      base.callApi(`/v1.1/sys/genre/del/${params.gid}`, 'POST', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then(data => {
        data.status === 'true' ? message.success('操作成功') : message.error('操作失败');
        resolve(data);
      });
    });
  }
  @action
  getCount = (params = {}) => {
    const param = {
      ...params,
      access_token: getAccessToken(),
    }
    return new Promise(resolve => {
      base.callApi('/v2/sys/count', 'GET', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then(data => {
        if (data.status === 'true') {
          this.mobilecount = data.mobilecount;
          this.pccount = data.pccount;
        }
        resolve(data);
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/stores/sys/sysStore.js